import "./App.css";
import React, { Suspense } from "react";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";
import { Provider } from "react-redux";
import { LanguageProvider, AuthProvider } from "./context";
import { store } from "@/store/index.js";
import {
  DEALERBUYPRESEARCH,
  GREATDEALS,
  VERIFYREGISTER,
  REGISTERAS,
  CATEGORIESITEM,
  PRIVACYPOLICY,
  TERMCONDITION,
  REFUNDPOLiCY,
  ADSPOLICY,
  SERVICEPROVIDERLIST,
  SERVICEPROVIDERPOSTING,
  INSURENCESERVICE,
  DEALERPLANSLIST,
  OTHERSREG,
  ADDZONELIST,
  ADDRESS,
  UPLOADPHOTOS,
  UPLOAD_STORY_PHOTOS,
  PREVIEWLISTINGPAGE,
  GENERAL_LISTING,
  DEALER_LISTING,
  DEALERPOSTINGS,
  PAYMENTSUMMARY,
  OFFERINFORMATION,
  OFFERRESULTS,
  OFFERZONE,
  OFFERZONELISTINGS,
  OFFERZONEPOSTING,
  PREVIEWPOSTINGPAGE,
  ADZONE_POSTING,
  CONTACT_US,
  ABOUT_US,
  BLOG,
  ADZONE,
  MY_TRANSACTION,
  MY_ADDRESS,
  MY_PROFILE,
  PROFILE_DETAILS,
  MY_DEALERSHIP,
  CHANGE_PASSWORD,
  AGENT_BANK_DETAILS,
  AGENT_CLUSTER,
  ASSIGNEE_OTP_LINK,
  INVOICE_LINK,
  SEARCH_LINK,
  SEARCH_LISTING_PREVIEW_LINK,
  MY_PLANS,
  USER_ONBOARDING,
  OTHER_FEATURE,
  DEALER_FEATURE,
  SERVICE_PROVIDER_FEATURE,
  PREFIX_USER_STORY,
  USER_STORY_PREVIEW_PAGE,
  USER_STORY_POSTING,
  AGRI_EXPERT_POSTING,
  PROFILE_LISTS,
  DEALER_PROFILE,
  PURCHASE_REQUEST,
  PURCHASE_REQUEST_DETAILS,
  PURCHASE_REQUEST_BUY_LEAD_LIST,
  PURCHASE_REQUEST_POSTING,
  COMPLETE_PROFILE,
  INVESTOR_CATEGORY_ID,
  DELETE_ACCOUNT,
} from "@/_constant";

import Loader from "@/_component/public/plugins/loader/loader";
import Footer from "@/_component/Common/theme/footer/Footer";
import ProtectedRoute from "@/pages/ProtectedRoute.js";
import Fallback from "@/pages/FallbackPage.js";
import { Header } from "./_component/Common/index.js";
import MyPlan from "./pages/profile/MyPlan.js";

import BaseReview from "./_component/shared/story/components/BaseReview";
import UserProfileDetail from "./_component/shared/user-profile-card/UserProfileDetail";
import {
  AGENT_MIS_REPORT,
  BUSINESS_DEVELOPER_BENEFITS,
  BUSINESS_DEVELOPER_DETAILS,
  BUSINESS_DEVELOPER_FEATURE,
  BUSINESS_DEVELOPER_PLANS,
  BUSINESS_DEVELOPER_PREFIX,
  CUSTOMER_DETAILS,
  CUSTOMER_FEATURE,
  CUSTOMER_PREFIX,
  DEALER_CATEGORIES,
  DEALER_DETAILS,
  DEALER_PLANS,
  DEALER_PORTFOLIO,
  DEALER_PREFIX,
  EXCLUSIVE_PROPERTIES,
  INVESTOR_DETAILS,
  INVESTOR_FEATURE,
  INVESTOR_PLANS,
  INVESTOR_PORTFOLIO,
  INVESTOR_PREFIX,
  MY_PORTFOLIO,
  PORTFOLIO_RATING,
  SERVICE_PROVIDER_CATEGORIES,
  SERVICE_PROVIDER_DETAILS,
  SERVICE_PROVIDER_PLANS,
  SERVICE_PROVIDER_PORTFOLIO,
  SERVICE_PROVIDER_PREFIX,
  TOP_PROPERTIES
} from "./_constant/urlconstants.js";

const Home = React.lazy(() => import("@/pages/home"));

/* Policies */
const Privacypolicy = React.lazy(() => import("@/pages/policy/privacypolicy/privacypolicy"));
const TermCondition = React.lazy(() => import("@/pages/policy/termsconditions/termcondition"));
const RefundPolicy = React.lazy(() => import("@/pages/policy/refund/refund"));
const AdsPolicy = React.lazy(() => import("@/pages/policy/adspolicy/adspolicy"));

const ContactUs = React.lazy(() => import("@/pages/contact-us/ContactUs"));
const Aboutus = React.lazy(() => import("@/pages/about-us/AboutUs"));
const Blog = React.lazy(() => import("@/pages/blogs/Blog"));
const Article = React.lazy(() => import("@/pages/blogs/articles/Article"));

const ChangePassword = React.lazy(() => import("@/pages/profile/ChangePassword"));
const Register = React.lazy(() => import("@/pages/auth/Signup"));
const VerifyOTP = React.lazy(() => import("@/pages/auth/VerifyOTP"));
const ResetPassword = React.lazy(() => import("@/pages/auth/ResetPassword"));
const DeleteAccount = React.lazy(() => import("@/pages/profile/DeleteAccount"));

const MyAddress = React.lazy(() => import("@/pages/profile/MyAddress"));
const MyProfile = React.lazy(() => import("@/pages/profile/MyProfile"));
const MyPortfolio = React.lazy(() => import("@/pages/portfolio/MyPortfolio"));
const PortfolioRating = React.lazy(() => import("@/pages/portfolio/PortfolioRating"));
const CompleteProfile = React.lazy(() => import("@/pages/profile/CompleteProfile"));

const Dealership = React.lazy(() => import("@/pages/profile/MyDealership"));
const DealershipDetail = React.lazy(() => import("@/pages/profile/DealershipDetail"));
const ProfileDetail = React.lazy(() => import("@/pages/profile/ProfileDetail"));
const BaseTransaction = React.lazy(() => import("@/pages/transaction/BaseTransaction"));
const MyTransaction = React.lazy(() => import("@/pages/transaction/MyTransaction"));
const TransactionDetails = React.lazy(() => import("@/pages/transaction/TransactionDetails"));


const MyListing = React.lazy(() => import("./_component/MyListing/MyListing"));
const GeneralListing = React.lazy(() => import("./_component/MyListing/GeneralListing"));
const DealerListing = React.lazy(() => import("./_component/MyListing/Dealer/DealerListing"));
const ServiceProviderListing = React.lazy(() => import("./_component/MyListing/serviceprovider/ServiceProviderListing"));
const AdZoneListing = React.lazy(() => import("./_component/MyListing/AddZone/AdZoneListing"));
const OfferZoneListing = React.lazy(() => import("./_component/MyListing/OfferZone/OfferZoneListing"));

const MyPosting = React.lazy(() => import("./_component/MyPostings/MyPosting.js"));
const GeneralPosting = React.lazy(() => import("./_component/MyPostings/GeneralPosting.js"));
const DealerPosting = React.lazy(() => import("./_component/MyPostings/DealerPostings/DealerPosting.js"));
const ServiceProviderPosting = React.lazy(() => import("./_component/MyPostings/serviceprovider/ServiceProviderPosting.js"));
const AdzonePosting = React.lazy(() => import("./_component/MyPostings/adzonePosting/AdZonePostings.js"));
const OfferZonePosting = React.lazy(() => import("./_component/MyPostings/offerZonePosting/OfferZonePosting.js"));
const UserStoryPosting = React.lazy(() => import("./_component/MyPostings/user-story/UserStoryPosting"));
const AgriExpertPosting = React.lazy(() => import("./_component/MyPostings/agri-expert/AgriExpertPosting"));
const PurchaseRequestPosting = React.lazy(() => import("./_component/MyPostings/purchase-request/PurchaseRequestPosting"));


const AdzonePreview = React.lazy(() => import("./_component/MyPostings/adzonepreview/adzonepreview"));
const PreviewPostingPage = React.lazy(() => import("./_component/from/previewPostingPage"));

const ChooseSellCategories = React.lazy(() => import("@/pages/choose-category/sell/ChooseSellCategories"));
const BaseCreatePost = React.lazy(() => import("@/pages/post/BaseCreatePost"));
const CreatePostRoute = React.lazy(() => import("@/pages/post/CreatePostRoute"));
const ListYourProperty = React.lazy(() => import("@/pages/post/ListYourProperty"));
const SellingAddress = React.lazy(() => import("@/pages/post/SellingAddress.js"));
const UploadPhotos = React.lazy(() => import("@/_component/from/addphoto/addphoto"));
const ListingPreview = React.lazy(() => import("@/pages/previews/ListingPreview.js"));
const AssigneeOTP = React.lazy(() => import("@/pages/post/AssigneeOtp.js"));
const PaymentSummary = React.lazy(() => import("@/pages/payments/PaymentSummary.js"));
const PaymentInvoice = React.lazy(() => import("@/pages/payments/PaymentInvoice.js"));


const MyLeads = React.lazy(() => import("./pages/leads/MyLeads"));
const AdZone = React.lazy(() => import("./_component/adzone/AdZone"));
const MyAppoinments = React.lazy(() => import("./pages/appointments/MyAppoinment"));

// Profile Dealer list
const UserProfileResult = React.lazy(() => import("./pages/user-listings/UserProfileResult"));

const DealerBuyPreSearch = React.lazy(() => import("./_component/choosepost/searchcategories/dealer_buy_preSearch"));
const SearchResult = React.lazy(() => import("./pages/search/SearchResult"));




const SearchResultDetails = React.lazy(() => import("./pages/search/SearchResultDetails"));

const GreatDealsSearch = React.lazy(() => import("./_component/choosepost/great_deals/great_deals"));
const TopProperties = React.lazy(() => import("./_component/choosepost/top-properties/TopProperties"));
const ExclusiveProperties = React.lazy(() => import("./_component/choosepost/exclusive-properties/ExclusiveProperties"));
const ChooseServiceCategories = React.lazy(() => import("@/pages/choose-category/services/ChooseServiceCategories"));
const Buy = React.lazy(() => import("@/pages/choose-category/buy/ChooseBuyCategories"));
const BuyListingDetails = React.lazy(() => import("./_component/MyListing/BuyListingDetails/BuyListingDetails"));

const RegisterAs = React.lazy(() => import("./pages/home/registeras/registeras"));
const UserOnboarding = React.lazy(() => import("@/pages/onboarding/UserOnboarding"));
const CustomerFeature = React.lazy(() => import("@/pages/onboarding/features/CustomerFeature"));
const DealerFeature = React.lazy(() => import("@/pages/onboarding/features/DealerFeature"));
const BusinessDeveloperFeature = React.lazy(() => import("@/pages/onboarding/features/BusinessDeveloperFeature"));
const InvestorFeature = React.lazy(() => import("@/pages/onboarding/features/InvestorFeature"));
const ServiceProviderFeature = React.lazy(() => import("@/pages/onboarding/features/ServiceProviderFeature"));
const OtherFeature = React.lazy(() => import("@/pages/onboarding/features/OtherFeature"));
const CustomerDetails = React.lazy(() => import("@/pages/onboarding/details/CustomerDetails"));
const DealerDetails = React.lazy(() => import("@/pages/onboarding/details/DealerDetails"));
const BusinessDeveloperDetails = React.lazy(() => import("@/pages/onboarding/details/BusinessDeveloperDetails"));
const InvestorDetails = React.lazy(() => import("@/pages/onboarding/details/InvestorDetails"));
const ServiceProviderDetails = React.lazy(() => import("@/pages/onboarding/details/ServiceProviderDetails"));
const OnboardingCategorySelection = React.lazy(() => import("@/_component/shared/onboarding/categories/OnboardingCategorySelection"));

const CategoriesItem = React.lazy(() => import("./_component/onboardusers/categorieslist/choosecategories"));

const DealerRegisterPortfolio = React.lazy(() => import("./_component/onboardusers/portfolio/dealerRegisterPortfolio"));
const Others = React.lazy(() => import("./_component/onboardusers/onbardingcategoriesfrom/others"));
const ServiceProviderRegisterPortfolio = React.lazy(() => import("./_component/onboardusers/portfolio/service_provider"));
const InvestorRegisterPortfolio = React.lazy(() => import("./_component/onboardusers/portfolio/investorRegisterPortfolio"));

const DealerPlansList = React.lazy(() => import("./_component/onboardusers/planlist/dealerlist/dealerlistplan"));
const AgentPlansList = React.lazy(() => import("./_component/onboardusers/planlist/agentlist/agentlistplan.js"));


/**Agent or Coordinator */
const AgentRankFeature = React.lazy(() => import("@/pages/agent/AgentRankFeature"));
const AgentBankDetails = React.lazy(() => import("@/pages/agent/AgentBankDetails"));
const AgentRefferals = React.lazy(() => import("@/pages/agent/AgentRefferals"));
const AgentMisReport = React.lazy(() => import("@/pages/agent/AgentMisReport"));

const OfferZone = React.lazy(() => import("./_component/offer/OfferZone"));
const OfferResults = React.lazy(() => import("./_component/offer/OfferResults"));
const OfferInformation = React.lazy(() => import("./_component/offer/OfferInformation"));

const Reviews = React.lazy(() => import("@/pages/review/Reviews"));
const AddReview = React.lazy(() => import("@/pages/review/AddReview"));

const CreateUserStory = React.lazy(() => import("@/pages/story/CreateUserStory"));
const CreateAgriExpertStory = React.lazy(() => import("@/pages/story/CreateAgriExpertStory"));
const StoryPreview = React.lazy(() => import("@/pages/story/StoryPreview"));

const PurchaseRequestChooseCategory = React.lazy(() => import("@/pages/purchase-request/PurchaseRequestChooseCategory"));
const PurchaseRequestDetails = React.lazy(() => import("./pages/purchase-request/PurchaseRequestDetails"));
const PurchaseRequestBuyLeadList = React.lazy(() => import("./pages/purchase-request/PurchaseRequestBuyLeadList"));

const InsurenceService = React.lazy(() => import("./_component/from/serviceprovider/insurenceService/create_post_InsurenceService"));

const Review = React.lazy(() => import("@/_component/shared/story/components/StoryDetails.js"));
const UserReviews = React.lazy(() => import("@/_component/shared/story/components/Stories.js"));

Amplify.configure(awsconfig);

function App() {

  return (
    <BrowserRouter>
      <Provider store={store}>
        <LanguageProvider>
          <AuthProvider>
            <Suspense fallback={<Loader />}>
              <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
              />
              <Header />
              <Routes>
                <Route exact path="/register" element={<Register />} />
                <Route exact path={VERIFYREGISTER} element={<VerifyOTP />} />
                <Route exact path={REGISTERAS} element={<RegisterAs />} />
                <Route exact path="/resetpassword" element={<ResetPassword />} />

                <Route exact path={CONTACT_US} element={<ContactUs />} />
                <Route exact path={ABOUT_US} element={<Aboutus />} />
                <Route path={BLOG} element={<Outlet />}>
                  <Route index element={<Blog />} />
                  <Route path={":category"} element={<Blog />} />
                  <Route path={":category/:articleSlug"} element={<Article />} />
                </Route>
                <Route exact path={PRIVACYPOLICY} element={<Privacypolicy />} />
                <Route exact path={TERMCONDITION} element={<TermCondition />} />
                <Route exact path={REFUNDPOLiCY} element={<RefundPolicy />} />
                <Route exact path={ADSPOLICY} element={<AdsPolicy />} />

                <Route path="/sell/:categoryKey" element={<ChooseSellCategories />} />
                <Route exact path="/list-your-property" element={<ListYourProperty />} />
                <Route path={"/services/:categoryKey"} element={<ChooseServiceCategories />} />

                <Route path="/buy/:categoryKey" element={<Buy />} />

                <Route exact path={SEARCH_LINK} element={<SearchResult />} />
                <Route path={SEARCH_LISTING_PREVIEW_LINK} element={<SearchResultDetails />} />
                <Route path={OFFERZONE} element={<OfferZone />} />
                <Route path={OFFERRESULTS} element={<OfferResults />} />
                <Route path={ADZONE} element={<AdZone />} />

                {/* Dealer and SP profile Listing  */}
                <Route exact path={PROFILE_LISTS} element={<UserProfileResult />} />
                <Route exact path={DEALER_PROFILE} element={<UserProfileDetail />} />


                {/* All protected routes should defined inside this route */}
                <Route element={<ProtectedRoute />}>
                  <Route index path="/" element={<Home />} />

                  <Route path="/posts" element={<BaseCreatePost />} >
                    <Route exact path=":postType/:categoryKey" element={<CreatePostRoute />} />
                  </Route>

                  {/* Review  */}
                  <Route exact path={"reviews"} element={<Reviews />} />
                  <Route exact path={"add-review"} element={<AddReview />} />

                  {/* User story and Agri Expert */}
                  <Route path={"/stories"} element={<Outlet />}>
                    <Route exact path={"users/create"} element={<CreateUserStory />} />
                    <Route exact path={"agri-experts/create"} element={<CreateAgriExpertStory />} />
                    <Route exact path={":storyId/preview"} element={<StoryPreview />} />
                    <Route exact path={":reviewType"} element={<UserReviews />} />
                    <Route exact path={":reviewType/:reviewId"} element={<Review />} />
                  </Route>

                  {/* My Listing Routes */}
                  <Route path="/listings" element={<MyListing />}>
                    <Route index element={<GeneralListing />} />
                    <Route exact path={""} element={<GeneralListing />} />
                    <Route path={GENERAL_LISTING} element={<GeneralListing />} />
                    <Route exact path={DEALER_LISTING} element={<DealerListing />} />
                    <Route exact path={SERVICEPROVIDERLIST} element={<ServiceProviderListing />} />
                    <Route exact path={OFFERZONELISTINGS} element={<OfferZoneListing />} />
                    <Route exact path={ADDZONELIST} element={<AdZoneListing />} />
                  </Route>

                  {/* My Posting Routes*/}
                  <Route path="/postings" element={<MyPosting />}>
                    <Route index element={<GeneralPosting />} />
                    <Route exact path={""} element={<GeneralPosting />} />
                    <Route exact path={DEALERPOSTINGS} element={<DealerPosting />} />
                    <Route exact path={SERVICEPROVIDERPOSTING} element={<ServiceProviderPosting />} />
                    <Route exact path={OFFERZONEPOSTING} element={<OfferZonePosting />} />
                    <Route exact path={ADZONE_POSTING} element={<AdzonePosting />} />
                    <Route exact path={USER_STORY_POSTING} element={<UserStoryPosting />} />
                    <Route exact path={AGRI_EXPERT_POSTING} element={<AgriExpertPosting />} />
                    <Route exact path={PURCHASE_REQUEST_POSTING} element={<PurchaseRequestPosting />} />
                  </Route>

                  {/* User Onboarding routes */}
                  <Route path={USER_ONBOARDING} element={<UserOnboarding />}>
                    <Route path={CUSTOMER_PREFIX}>
                      <Route path={CUSTOMER_FEATURE} element={<CustomerFeature />} />
                      <Route path={CUSTOMER_DETAILS} element={<CustomerDetails />} />
                    </Route>
                    <Route exact path={OTHER_FEATURE} element={<OtherFeature />} />
                    <Route path={DEALER_PREFIX}>
                      <Route path={DEALER_FEATURE} element={<DealerFeature />} />
                      <Route path={DEALER_CATEGORIES} element={<OnboardingCategorySelection accessType="dealer" />} />
                      <Route path={DEALER_DETAILS} element={<DealerDetails />} />
                      <Route path={DEALER_PORTFOLIO} element={<DealerRegisterPortfolio />} />
                      <Route path={DEALER_PLANS} element={<DealerPlansList accessType="dealer" />} />
                    </Route>
                    <Route path={BUSINESS_DEVELOPER_PREFIX}>
                      <Route path={BUSINESS_DEVELOPER_FEATURE} element={<BusinessDeveloperFeature />} />
                      <Route path={BUSINESS_DEVELOPER_BENEFITS} element={<AgentRankFeature />} />
                      <Route path={BUSINESS_DEVELOPER_DETAILS} element={<BusinessDeveloperDetails />} />
                      <Route path={BUSINESS_DEVELOPER_PLANS} element={<AgentPlansList />} />
                    </Route>
                    <Route path={INVESTOR_PREFIX}>
                      <Route path={INVESTOR_FEATURE} element={<InvestorFeature />} />
                      <Route path={INVESTOR_DETAILS} element={<InvestorDetails />} />
                      <Route path={INVESTOR_PORTFOLIO} element={<InvestorRegisterPortfolio />} />
                      <Route path={INVESTOR_PLANS} element={<DealerPlansList accessType="investor" fixedCategoryId={INVESTOR_CATEGORY_ID} planType="INVESTOR" />} />
                    </Route>
                    <Route path={SERVICE_PROVIDER_PREFIX}>
                      <Route path={SERVICE_PROVIDER_FEATURE} element={<ServiceProviderFeature />} />
                      <Route path={SERVICE_PROVIDER_CATEGORIES} element={<OnboardingCategorySelection accessType="service-provider" />} />
                      <Route path={SERVICE_PROVIDER_DETAILS} element={<ServiceProviderDetails />} />
                      <Route path={SERVICE_PROVIDER_PORTFOLIO} element={<ServiceProviderRegisterPortfolio />} />
                      <Route path={SERVICE_PROVIDER_PLANS} element={<DealerPlansList accessType="service-provider" />} />
                    </Route>
                  </Route>

                  {/* --------------- create post pages --------------- */}
                  <Route path="/post" element={<BaseCreatePost />}>
                    <Route exact path={INSURENCESERVICE} element={<InsurenceService />} />
                    <Route exact path={OFFERINFORMATION} element={<OfferInformation />} />
                  </Route>

                  <Route path={PURCHASE_REQUEST}>
                    <Route index element={<PurchaseRequestChooseCategory />}></Route>
                    <Route exact path={PURCHASE_REQUEST_DETAILS} element={<PurchaseRequestDetails />}></Route>
                    <Route exact path={PURCHASE_REQUEST_BUY_LEAD_LIST} element={<PurchaseRequestBuyLeadList />}></Route>
                  </Route>

                  <Route exact path={ADDRESS} element={<SellingAddress />} />
                  <Route exact path={UPLOADPHOTOS} element={<UploadPhotos />} />
                  <Route exact path={PREVIEWLISTINGPAGE} element={<ListingPreview />} />
                  <Route exact path={PREVIEWPOSTINGPAGE} element={<PreviewPostingPage />} />

                  <Route exact path={PAYMENTSUMMARY} element={<PaymentSummary />} />
                  <Route exact path={DEALERBUYPRESEARCH} element={<DealerBuyPreSearch />} />
                  <Route exact path={GREATDEALS} element={<GreatDealsSearch />} />
                  <Route exact path={EXCLUSIVE_PROPERTIES} element={<ExclusiveProperties />} />
                  <Route exact path={TOP_PROPERTIES} element={<TopProperties />} />

                  <Route exact path={CATEGORIESITEM} element={<CategoriesItem />} />

                  <Route exact path={OTHERSREG} element={<Others />} />
                  <Route exact path={DEALERPLANSLIST} element={<DealerPlansList />} />

                  <Route exact path={INVOICE_LINK} element={<PaymentInvoice />} />

                  <Route exact path={"/adzonePreviewPosting"} element={<AdzonePreview />} />
                  <Route exact path={"/adzonePreviewListing"} element={<AdzonePreview />} />
                  <Route path={ASSIGNEE_OTP_LINK} element={<AssigneeOTP />} />

                  <Route path="/MyLeads" element={<MyLeads />} />
                  <Route path="/adzone/:id" element={<AdZone />} />
                  <Route path="/myappoinments" element={<MyAppoinments />} />

                  <Route path={AGENT_MIS_REPORT} element={<AgentMisReport />} />
                  <Route path={AGENT_BANK_DETAILS} element={<AgentBankDetails />} />
                  <Route path={AGENT_CLUSTER} element={<AgentRefferals />} />

                  <Route path="/BuyListings" element={<BuyListingDetails />} />

                  <Route path={MY_TRANSACTION} element={<BaseTransaction />}>
                    <Route path={""} element={<MyTransaction />} index />
                    <Route exact path={`${MY_TRANSACTION}/:id`} element={<TransactionDetails />} />
                  </Route>

                  <Route path={MY_PROFILE} element={<MyProfile />} />
                  <Route path={MY_PORTFOLIO} element={<MyPortfolio />} />
                  <Route path={PORTFOLIO_RATING} element={<PortfolioRating />} />
                  <Route path={COMPLETE_PROFILE} element={<CompleteProfile />} />

                  <Route path={PROFILE_DETAILS} element={<ProfileDetail />} />
                  <Route path={CHANGE_PASSWORD} element={<ChangePassword />} />
                  <Route path={MY_DEALERSHIP} element={<Dealership />} />
                  <Route path="/dealership-detail/:id" element={<DealershipDetail />} />
                  <Route path={MY_ADDRESS} element={<MyAddress />} />
                  <Route path={MY_PLANS} element={<MyPlan />} />
                  <Route path={DELETE_ACCOUNT} element={<DeleteAccount />} />
                </Route>

                {/* Fallback Routes if route does not found */}
                <Route path="/unauthorized" element={<Fallback errorCode={403} />}></Route>
                <Route path="*" element={<Fallback errorCode={404} />}></Route>

              </Routes>
              <Footer />
            </Suspense>
          </AuthProvider>
        </LanguageProvider>
      </Provider>
    </BrowserRouter>
  );
}

export default App;
